<div class="price-table-section">
    <p class="unlimited-global" *ngIf="!inModal">Unlimited Global <strong>150+</strong> Countries.</p>
    <div class="search-box" [ngClass]="{'invalid': !countries?.length}">
        <div class="input-container">
            <input #searchInput (input)="search($event.target.value)" placeholder="Search for a Country">
            <p *ngIf="showValidationError" class="caption mb-0 invalid-country-message">Enter a Valid Country</p>
        </div>
        <div>
            <img src="assets/icon/search.svg">
        </div>
    </div>
    <div class="regions-filters" *ngIf="!inModal">
        <p class="filter-by-title smaller"><b>Filter by Region:</b></p>
        <div class="regions">
            <button *ngFor="let region of regions" class="button tertiary"
                [class.region-active]="selectedRegion==region" (click)="selectRegion(region)">{{region}}</button>
        </div>
    </div>
    <section class="international-calling-section" id="contentSection">
        <p *ngIf="countries?.length && !inModal" class="caption results-count-margin"><strong>{{countries?.length}}</strong> Results
            for
            “{{searchInput?.value || selectedRegion}}”</p>
        <div *ngIf="countries?.length" class="header-section">
            <div class="titles-container" [class.split-style]="countries?.length > splitLimit">
                <div class="titles-container1">
                    <div class="titles">
                        <p class="title smaller text-bold">Countries</p>
                        <p class="title smaller text-bold">{{valueTitle}}</p>
                    </div>
                    <p class="border"></p>
                </div>
                <div class="titles-container2" *ngIf="countries?.length > splitLimit">
                    <div class="titles">
                        <p class="title smaller text-bold">Countries</p>
                        <p class="title smaller text-bold">{{valueTitle}}</p>
                    </div>
                    <p class="border"></p>
                </div>
            </div>
        </div>
        <p *ngIf="!countries?.length" class="smaller text-bold text-center mb-0">No Data Found</p>
        <div class="contents-section content-section-split-style" [class.column-style]="countries?.length < splitLimit">
            <div class="contents" [class.w-100]="!(countries?.length > splitLimit)"
                *ngFor="let item of countries | paginate : config;let i =index;">
                <div class="top-section"><img class="flag-icon"
                        src="https://{{item?.fields?.countryFlagUrl.fields?.file.url}}">
                    <p class="smaller country-name">{{item?.fields?.countryName}}</p>
                </div>
                <div class="offerings" *ngIf="item?.fields?.countryOfferings">
                    <div class="offers" *ngFor="let offer of item?.fields?.countryOfferings">
                        <p class="caption offer-key">{{offer?.fields?.key ? offer?.fields?.key : '--'}}</p>
                        <p class="caption offer-value">{{offer?.fields?.value ? offer?.fields?.value : '--'}}</p>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="countries?.length > 30">
            <app-custom-pagination [config]="config"
                (configChange)="pageChanged($event)"></app-custom-pagination>
        </div>
    </section>
</div>
